import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environments';

@Component({
  selector: 'rap-stripe-pricing',
  templateUrl: './stripe-pricing.component.html',
  styleUrls: ['./stripe-pricing.component.scss']
})
export class StripePricingComponent {
  pricingTableId = environment.stripe.pricingTableId

  publishableKey = environment.stripe.publishableKey

  // pricingTableId = environment.stripe.pricingTableId;
  // publishableKey = environment.stripe.publishableKey;
  iframeSrc: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    const url = `https://buy.stripe.com/pricing-table/${this.pricingTableId}?publishableKey=${this.publishableKey}`;
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


  ngOnInit() {
  }
}
